<template>
  <div class="mt-8 w-full h-full bg-white">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'OutletView',
  mounted() {
    try {
      this.$store.dispatch('OutletModule/fetchAllOutlets');
    } catch (e) {
      this.$notify.error({
        title: 'Error',
        message: 'Something went wrong please try again.',
      });
    }
  },
};
</script>

<style scoped>

</style>
